import React, { useCallback, useState } from 'react';
import { compose, pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { GamesView } from 'js/components/common/GamesView';
import { defaultProps, withHandlers, withProps } from 'recompose';

import ViewMore from './ViewMore';
import { CATEGORY_TYPE } from './constants';

import style from './index.scss';

export const Category = ({
    gameCodes,
    setCategoryRef,
    displayMode,
    gameSize,
    scrollIntoView,
    className = '',
    title,
    showTitle,
    showViewMore,
    onActiveSlideChange,
    cid,
    type,
    Game,
    expandedCategory,
    setExpandedCategory,
    sliderOptions
}) => {
    const expanded = expandedCategory === cid;
    const isPinned = type === CATEGORY_TYPE.PINNED;
    const categoryClsName = [
        className,
        style.category,
        type === CATEGORY_TYPE.TAB && style.tab,
        isPinned && style.pinned,
        expanded && style.expanded
    ].filter(Boolean).join(' ');

    const [slidesLength, setSlidesLength] = useState(0);
    const viewMoreClickHandler = useCallback((event) => {
        event.preventDefault();

        setExpandedCategory(expandedCategory !== cid ? cid : null);
    }, [expandedCategory, cid, setExpandedCategory]);

    return (
        <div ref={setCategoryRef} className={categoryClsName}>
            {showTitle && (
                <h2 className={style.heading}>
                    {title}
                    {showViewMore && slidesLength > 1 && (
                        <ViewMore
                            expanded={expanded}
                            onClick={viewMoreClickHandler}
                        />
                    )}
                </h2>
            )}

            <GamesView
                displayMode={displayMode}
                gameSize={gameSize}
                gameCodes={gameCodes}
                scrollIntoView={scrollIntoView}
                setSlidesLength={setSlidesLength}
                onActiveSlideChange={onActiveSlideChange}
                expanded={expanded}
                showDivider={isPinned}
                Game={Game}
                sliderOptions={sliderOptions}
            />
        </div>
    );
};

export default compose(
    defaultProps({ showTitle: true }),
    withProps(() => useAppSelector(pick(['headerHeight']))),
    withHandlers(() => {
        let categoryRef;

        return {
            setCategoryRef: () => ref => categoryRef = ref,
            scrollIntoView: ({ headerHeight }) => () => {
                const { documentElement, body } = document;
                const { top: categoryTop } = categoryRef.getBoundingClientRect();
                const top = categoryTop + (documentElement.scrollTop || body.scrollTop) - headerHeight;

                window.scrollTo(0, top);
            }
        };
    })
)(Category);
